import { render, staticRenderFns } from "./coverageList.vue?vue&type=template&id=03bd8a4d&scoped=true"
import script from "./coverageList.vue?vue&type=script&lang=js"
export * from "./coverageList.vue?vue&type=script&lang=js"
import style0 from "./coverageList.vue?vue&type=style&index=0&id=03bd8a4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd8a4d",
  null
  
)

export default component.exports